<template>
  <div
    class="aside-scrollable personal-chats"
    :class="accordionClasses"
  >
    <p
      class="aside-menu__title"
      @click="toggleAccordion"
    >
      {{ $t("personal_chats") }}
      <span class="aside-menu__arrow-box"></span>
    </p>
    <vue-custom-scrollbar
      class="accordion scroll-area"
      :settings="settings"
    >
      <ul
        id="personal-menu"
        class="aside-menu aside-menu--chats"
      >
        <app-left-panel-personal-chat
          v-for="chat in chats"
          :chat="chat"
          :key="chat.id"
          :chats="chats"
        ></app-left-panel-personal-chat>
      </ul>
    </vue-custom-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import LeftPanelPersonalChat from './LeftPanelPersonalChat.vue';
import vueCustomScrollbar from 'vue-custom-scrollbar';
import env from '../../env';

export default {
  components: {
    appLeftPanelPersonalChat: LeftPanelPersonalChat,
    vueCustomScrollbar: vueCustomScrollbar,
  },
  data: () => ({
    env,
    computedChats: [],
    isOpen: true,
    settings: {
      maxScrollbarLength: 60,
      swipeEasing: true,
    },
  }),
  methods: {
    toggleAccordion() {
      this.isOpen = !this.isOpen;
    },
  },
  computed: {
    ...mapGetters([
      'personalChats',
      'channelStudents',
      'userData',
      'chatsWithMe',
    ]),
    chats() {
      let chat = [];

      this.personalChats.forEach(item => {
        if (item.members && item.members.length) {
          if (!item.members[0].is_online) item.members[0].is_online = false;
          if (item.members[0].id !== this.userData.id)
            chat.push(item.members[0]);
          if (item.members[1] && item.members[1].id !== this.userData.id)
            chat.push(item.members[1]);
        }
      });
      // chat = chat.sort((a, b) => (a.is_online < b.is_online) ? 1 : -1);
      this.personalChats.forEach(c => {
        if (c.members.length) {
          c.members.forEach(member => {
            chat.forEach(chat => {
              if (member.id === chat.id) {
                chat['last_msg_datetime'] = c.last_msg_datetime;
                chat['unread_messages_count'] = c.unread_messages_count;
              }
            });
          });
        }
      });

      // let chatsUnread = [], chatsOffline = [];
      // chat.forEach(c => c.unread_messages_count ? chatsUnread.push(c) : chatsOffline.push(c));
      //   chat.forEach(item => console.log(item.last_msg_datetime, 'time'));
      chat.sort((a, b) =>
        a.last_msg_datetime > b.last_msg_datetime ||
        typeof a.last_msg_datetime === 'undefined' ||
        typeof b.last_msg_datetime === 'undefined'
          ? -1
          : 1,
      );
      // chat = [...chatsUnread, ...chatsOffline];
      return chat;
    },
    accordionClasses: function() {
      return {
        'is-closed': !this.isOpen,
        'is-primary': this.isOpen,
      };
    },
  },
};
</script>

<style scoped>
.scroll-area {
  position: relative;
  margin: auto;
  width: 100%;
  height: 100%;
}

.accordion {
  max-height: 100%;
  transition: 0.3s ease all;
}

.is-closed .accordion {
  max-height: 0;
}
</style>
